"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleInventoryListQuery = exports.getVehicleInventoryQuery = void 0;
exports.getVehicleInventoryQuery = `
  query vehicleInventoryQuery($pimCode: String!, $make: String) {
    vehicleInventory(pimCode: $pimCode, make: $make) {
      actualProductionDate
      brand
      interiorHexCode
      isReserved
      isSecondHandVehicle
      location
      locationName
      make
      model
      price
      productionDate
      reservedToDateTime
      salesPackages
      serialNumber
      series
      stockAvailabilityCode
      trackAndTrace
      varnishHexCode
      vehicleType
      vin
    }
  }
`;
exports.getVehicleInventoryListQuery = `
  query vehicleInventoryListQuery($pimCodes: [String!]) {
    vehicleInventoryList(pimCodes: $pimCodes) {
      vehicleModel
      featureSetStandardId
      available
      locations {
        code
        available
      }
      vehicles {
        vehicleId
        locationId
        stockAvailabilityCode
        stockOwnerType
      }
    }
  }
`;
//# sourceMappingURL=vehicle-inventory.js.map